import React from 'react';
import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import { linkedin, github, line, hero } from '../assets';

const Typewriter = ({ text, className }) => {
  const characters = text.split('');
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  return (
    <div>
      {characters.map((char, index) => (
        <motion.span
          key={index}
          variants={variants}
          initial="hidden"
          animate="visible"
          transition={{ delay: index * 0.1 }}
          className={className}
        >
          {char}
        </motion.span>
      ))}
    </div>
  );
};

const Hero = () => (
  <section className="bg-lightGray dark:bg-black3 transition" id="hero">
    <div className="wrapper flex flex-col md:flex-row justify-between items-center pt-[120px] pb-[80px] gap-12">
      <div className="pt-[40px] w-full xl:w-[600px] text-center md:text-left">
        <Typewriter
          text="Hi, I am Nenad"
          className="text-base md:text-lg font-bold leading-5 text-primaryBlue tracking-[0.5em] uppercase"
        />
        <div className="title dark:before:bg-primaryOrange/25">
          <h1 className="relative mx-auto md:mx-0 max-w-[315px] md:max-w-[550px] text-primaryBlack text-[36px] md:text-[66px] leading-[52px] md:leading-[82px]
           font-extrabold md:font-bold dark:text-white transition-all"
          >
            Proffesional Web Developer based in Serbia
          </h1>
        </div>
        <p className="text-xs md:text-base font-normal leading-7 md:leading-9 text-primaryGray pt-7 max-w-[1000px]">
          My passion is creating web applications that are both functional and
          beautiful. I enjoy working with designers and project managers to
          deliver high-quality products that meet the needs of clients and end
          users.
        </p>
        <div className="pt-7 flex flex-col md:flex-row items-center">
          <Link
            to="/contact"
            type="button"
            className="button"
          >
            Contact Me
          </Link>
          <div className="flex pl-0 md:pl-10 pt-9 md:pt-0 gap-8">
            <a
              href="https://www.linkedin.com/in/nenad-baltic"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={linkedin}
                alt="linkedin"
                className="w-[25px] grayscale hover:grayscale-0 hover:scale-110 transition duration-300"
              />
            </a>
            <a
              href="https://www.github.com/nenadbaltic"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={github}
                alt="github"
                className="w-[25px] grayscale hover:grayscale-0 hover:scale-110 transition duration-300"
              />
            </a>
            <img src={line} alt="line" className="hidden md:block ml-10" />
          </div>
        </div>
      </div>

      <img src={hero} alt="hero" className="sm:block md:hidden xl:block w-[80%] md:w-[550px] 2xl:w-[600px] transition-all" />
    </div>
  </section>
);

export default Hero;
